export default {"src":"/_next/static/media/logo-white.9727d2a2.svg","height":141,"width":114};